// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HamburgerController from "./hamburger_controller"
application.register("hamburger", HamburgerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LightTimeSwitchController from "./light_time_switch_controller"
application.register("light-time-switch", LightTimeSwitchController)

import GrantPurificationTimeModalController from "./grant_purification_time_modal_controller"
application.register("grant-purification-time-modal", GrantPurificationTimeModalController)

import PomodoroController from "./pomodoro_controller"
application.register("pomodoro", PomodoroController)

import PomodoroSettingModalController from "./pomodoro_setting_modal_controller"
application.register("pomodoro-setting-modal", PomodoroSettingModalController)

import PurificationTimerController from "./purification_timer_controller"
application.register("purification-timer", PurificationTimerController)

import MystatusChartController from "./mystatus_chart_controller"
application.register("mystatus-chart", MystatusChartController)

import MystatusRadarChartController from "./mystatus_radar_chart_controller"
application.register("mystatus-radar-chart", MystatusRadarChartController)

import ActivityLockController from "./activity_lock_controller"
application.register("activity-lock", ActivityLockController)

import GuestHeartbeatController from "./guest_heartbeat_controller"
application.register("guest-heartbeat", GuestHeartbeatController)
